import { Organization } from "./Organization";
import { User } from "./User";
import { SterilizationStatus } from './SterilizationStatus';

export enum PatientSex {
    "NotSpecified" = "N/A",
    "Male" = "Male",
    "Female" = "Female",
}

export class Patient {
    id: string = "";
    name: string = "";
    ownerLastName: string = "";
    dateOfBirth: string = "";
    sex: keyof typeof PatientSex = "NotSpecified";
    breed: string ="";
    phoneNumber: string = "";
    organizationId: string = "";
    organization: Organization | null = null;
    caregiver: User | null = null;
    sterilizationStatus: SterilizationStatus = SterilizationStatus.None;
    isDefault: boolean = false;
    lastActivityTime: string | null = null;

    constructor(init:Partial<Patient> = {}) {
        Object.assign(this, init);

        if (init.organization) {
            this.organization = new Organization(init.organization);
        }

        if (init.caregiver) {
            this.caregiver = new User(init.caregiver);
        }

        this.sterilizationStatus = init.sterilizationStatus ?? SterilizationStatus.None;
        
        this.isDefault = init.isDefault ?? false;
    }

    toDisplayIdentifier(): string {
        if (this.id === "") {
            return "New Patient";
        }
        if (!this.name && !this.ownerLastName) {
            return `ID ${this.id.slice(-8).toUpperCase()}`;
        }

        if (!this.name) {
            return `${this.ownerLastName}'s Pet`;
        }

        if (!this.ownerLastName) {
            return this.name;
        }

        return `${this.name}, ${this.ownerLastName}`;
    }

    toDetailPageUrl(): string {
        return `/patients/${this.id}`;
    }

    get profilePictureUrl(): string {
        var params = new URLSearchParams();
        if (this.lastActivityTime) {
            params.set('v', this.lastActivityTime);
        }
        return `/api/patients/${this.id}/profile-picture?${params.toString()}`;
    }
}
